import React, { useState, useEffect } from "react"
import _ from 'lodash'
// Components
import { CheckboxInput, ListboxInput } from "components/table/carousel/inputs"
// Data
import portfolioService from "data/portfolio"
import { alphanum } from "components/table/lib/sort"
// Styles
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { ListboxSection_s, ListboxHeaderSort_s, SelectAllCheckbox_s } from "styles/input-styles"

const UserAccess = (props: {rowData: {}, namedItems: string[]}) => {

  let userGroups = _.get(props, "namedItems.userGroups");
  let userGroupOptions = userGroups?.map((group) => {
    return { label: `${group.code} - ${group.name ? group.name : ''}`, value: group.usergroupid }
  })

  const [selectedGroups, setSelectedGroups] = useState<[]>([]);
  const [showSelected, setShowSelected] = useState<boolean>(false);
  const [sortDirty, setSortDirty] = useState<boolean>(false);
  const [sortAsc, setSortAsc] = useState<boolean>(true);

  useEffect(() => {
    portfolioService.fetch(_.get(props, "rowData.portfolioid"))
      .then((portfolio) => {
        setSelectedGroups(_.chain(portfolio).get('usergroups').map('usergroupid').uniq().value())
      })
  }, [])

  function updateData(val:any):void {
    setSelectedGroups(val)
    let payload = _.cloneDeep(props.rowData)
    if(val.length) payload.usergroups = _.map(val, (groupid) => { return { usergroupid: groupid } })
    else payload.usergroups = val
    portfolioService.patch(payload)
  }

  function selectAll():void {
    if(selectedGroups.length === userGroupOptions.length) updateData([])
    else updateData(_.map(userGroupOptions, (group) => group.value))
  }

  if(sortDirty) {
    sortAsc ? userGroupOptions.sort((a, b) => alphanum(a.label, b.label)) : userGroupOptions.sort((a, b) => alphanum(b.label, a.label))
  }

  if(showSelected) {
    userGroupOptions = _.intersectionBy(userGroupOptions, _.map(selectedGroups, (g) => { return {label: '', value: g} }), "value")
  }

  return (
    <SingleRowCarouselState_s>
      <div>
        <label>Show Selected</label>
        <CheckboxInput className="automated" data={{showSelected}} field='showSelected' persist={(val, field) => setShowSelected(val)} />
      </div>
      <ListboxSection_s>
        <ListboxHeaderSort_s>
          <label>User Groups</label>
          <a onClick={(e) => { sortDirty === false ? setSortDirty(true) : setSortAsc(!sortAsc)}}>
            { !sortDirty && <i className="pi pi-sort-alt" style={{height: '18px', width: '18px'}} /> }
            { sortDirty && sortAsc && <i className="pi pi-sort-amount-down" style={{height: '18px', width: '18px'}} /> }
            { sortDirty && !sortAsc && <i className="pi pi-sort-amount-up" style={{height: '18px', width: '18px'}} /> }
          </a>
        </ListboxHeaderSort_s>
        <SelectAllCheckbox_s className="automated" data={{allSelected: selectedGroups ? selectedGroups.length === userGroups.length : false}} field='allSelected' persist={selectAll} />
        <ListboxInput
          className="automated"
          data={{"items": selectedGroups}}
          field="items"
          multiple={true}
          persist={updateData}
          options={userGroupOptions}
        />
      </ListboxSection_s>
    </SingleRowCarouselState_s>
  )
}

export default UserAccess
